import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import errorimage from '../../img/product/error.png'
import { useNavigate } from "react-router-dom";

const ProductDetails = ({ setActiveMenuItem, setIsLoading }) => {
  const navigate = useNavigate();
  const formRef = useRef();
  const handleOrderButtonClick = () => {
    formRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  //************************************* Getting prduct details ********************* */
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [productData, setProductData] = useState({})
  const [imgSrc, setImgSrc] = useState()
  const [imageArray, setImageArray] = useState([])
  const [colorsArray, setColorsArray] = useState([])
  const [sizesObject, setSizesObject] = useState({})
  const [orderedQuantity, setOrderedQuantity] = useState("1")
  const [orderedColor, setOrderedColor] = useState("")
  const [selectedSize, setSelectedSize] = useState("XS");
  const [prenom, setPrenom] = useState("");
  const [nom, setNom] = useState("");
  const [telephone, setTelephone] = useState("");
  const [gouvernorat, setGouvernorat] = useState("");
  const [ville, setVille] = useState("");
  const [adresse, setAdresse] = useState("");
  const [note, setNote] = useState("");

  

  useEffect(() => { setIsLoading(true); setActiveMenuItem('Accueil'); axios.get(`${baseUrl}/product`).then(({ data }) => { setProductData(data[0]); setImageArray(JSON.parse(data[0].imgSrcArray)); setImgSrc((JSON.parse(data[0].imgSrcArray))[0]); setColorsArray(JSON.parse(data[0].colors)); setSizesObject(JSON.parse(data[0].sizes)); }).then(() => setIsLoading(false)).catch((err) => { console.log(err); setIsLoading(false); setServerError(true) }) }, [])

  //************************************* Orders ************************************ */

  var order = {
    product_name: productData.product_name,
    color: orderedColor,
    size: selectedSize,
    price: productData.price,
    quantity: orderedQuantity,
    shipping_fee: productData.shipping_fee,
    client_name: prenom + " " + nom,
    telephone: telephone,
    address: adresse + " - " + ville + " - " + gouvernorat,
    note: note,
    Status: "en attente"
  }

  // ************************************************************************************
  const emptyForm = () => { setOrderedColor(""); setOrderedQuantity("1"); setPrenom(""); setNom(""); setTelephone(""); setAdresse(""); setVille(""); setGouvernorat(""); setNote("") }
  //****************************************** Error handling ********************************************************** */

  const [error, setError] = useState(null);
  const [showClass, setShowClass] = useState("");

  const handleError = (str) => {
    setError(str);
    setShowClass('show')
    setTimeout(() => {
      setError(null);
      setShowClass('')
    }, 5000);
  };
  //****************************************** Success handling ******************************************************* */

  const handleSuccess = () => {
    navigate("/commande-succès-page")
  };


  //******************************************** API REQUEST ************************************************************* */
  const hundleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true)
    if (prenom.length && nom.length && telephone.length && gouvernorat.length && ville.length && adresse.length) {
        axios.post(`${baseUrl}/orders/add`, order).then(() => { handleSuccess(); emptyForm() }).catch((err) => { console.log(err); handleError('Problème de communication avec le serveur veuillez réessayer.') }).finally(() => {
          setIsLoading(false);
        });
    }
    else {
      handleError('Tous les champs avec * sont obligatoires.');
      setIsLoading(false);
    }
  }


  //************************************* ERROR ************************************* */

  const trueSizes = Object.entries(sizesObject)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const sortedTrueSizes = trueSizes.sort((a, b) => {
    const sizeOrder = { XS: 0, S: 1, M: 2, L: 3, XL: 4, XXL: 5, XXXL: 6 };
    return sizeOrder[a] - sizeOrder[b];
  });


  useEffect(() => {
    if (sortedTrueSizes.length > 0) {
      setSelectedSize(sortedTrueSizes[0]);
    }
  }, [sortedTrueSizes]);

  //************************************* ERROR ************************************* */
  const [serverError, setServerError] = useState(false)
  const containerStyle = {
    textAlign: 'center',
    marginTop: '50px',
  };

  const headingStyle = {
    fontSize: '2em',
    color: '#c0392b', // Red color
  };

  const messageStyle = {
    fontSize: '1.2em',
    marginBottom: '20px',
  };


  const detailsTextStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };
  //************************************* ERROR ************************************* */
  return (
    <>
      {serverError && <section className="product-details spad">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="product__details__text" style={{ ...containerStyle, ...detailsTextStyle }}>
                <img src={errorimage} alt="" style={{ width: '120px', height: '120px' }} />
                <h3 style={headingStyle}>
                  Error !!
                </h3>
                <p style={messageStyle}>Erreur de communication avec le serveur.</p>
                <div className="product__details__button">
                  <a className="cart-btn" onClick={() => { window.location.reload(); }} style={{ cursor: 'pointer' }}> Réessayer</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>}
      {imgSrc && (<section className="product-details spad">
        <div className={`error-message ${showClass}`}>

          <div className="close-button" onClick={() => { setError(null); setShowClass('') }}>
            X
          </div>
          <div className="message-content">{error}</div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="product__details__pic">
                <div className="product__details__pic__left product__thumb nice-scroll">
                  <a className="pt active" onClick={() => setImgSrc(imageArray[2])}>
                    <img src={imageArray[6]} alt="" />
                  </a>
                  <a className="pt" onClick={() => setImgSrc(imageArray[0])}>
                    <img src={imageArray[4]} alt="" />
                  </a>
                  <a className="pt" onClick={() => setImgSrc(imageArray[1])}>
                    <img src={imageArray[5]} alt="" />
                  </a>
                  <a className="pt" onClick={() => setImgSrc(imageArray[3])}>
                    <img src={imageArray[7]} alt="" />
                  </a>
                </div>
                <div className="product__details__slider__content">
                  <div className="product__details__pic__slider owl-carousel">
                    <img className="product__big__img" src={imgSrc} alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="product__details__text">
                <h3>{productData.product_name} <span>Marque: {productData.brand}</span></h3>
                <div className="rating">
                  <i className="fa fa-star" style={{ marginRight: '1px' }}></i>
                  <i className="fa fa-star" style={{ marginRight: '1px' }}></i>
                  <i className="fa fa-star" style={{ marginRight: '1px' }}></i>
                  <i className="fa fa-star" style={{ marginRight: '1px' }}></i>
                  <i className="fa fa-star"></i>
                  <span>( 237 reviews )</span>
                </div>
                <div className="product__details__price">{(productData.price*1).toFixed(1)} DT<span>{(productData.price * 1.1).toFixed(0) + ".0"} DT</span></div>
                <p>{productData.description.slice(0, 145)} .....</p>
                <div className="product__details__button">
                  <div className="quantity">
                    <span>Quantité:</span>
                    <div className="pro-qty">
                      <input type="number" defaultValue={orderedQuantity} min={1} onChange={(e) => setOrderedQuantity(e.target.value)} />
                    </div>
                  </div>
                  <a className="cart-btn" style={{ cursor: 'pointer' }} onClick={handleOrderButtonClick}><span className="arrow_carrot-2down"></span> Commander</a>
                </div>
                <div className="product__details__widget">
                  {/* --------------------------------------------------------------- */}
                  <ul>
                    <li>
                      <span>Disponibilité:</span>
                      <div className="stock__checkbox">
                        <label htmlFor="stockin">
                          En stock
                        </label>
                      </div>
                    </li>
                    <li>
                      <span>Couleurs:</span>
                      <div className="color__checkbox">
                        {colorsArray.map((color, index) => (
                          <label htmlFor={color} key={index}>
                            <input type="radio" name="color__radio" id={color} onClick={(e) => setOrderedColor(e.target.id)} />
                            <span className="checkmark border" style={{ backgroundColor: color }}></span>
                          </label>
                        ))}
                      </div>
                    </li>
                    {productData.multi_tailles == 1 && <li>
                      <span>Tailles disponibles:</span>
                      <div className="size__btn">
                        {sortedTrueSizes.map((size, index) => (
                          <label htmlFor={`${size.toLowerCase()}-btn`} className={selectedSize == size ? "active" : ""} onClick={() => { setSelectedSize(size); }} key={index}>
                            <input type="radio" id={`${size.toLowerCase()}-btn`} />
                            {size.toLowerCase()}
                          </label>
                        ))}
                      </div>
                    </li>}
                    <li>
                      <span>Promotions:</span>
                      {productData.shipping_fee == 0 ? <p>Livraison gratuite</p> : <p>10% Remise</p>}
                    </li>
                  </ul>
                  {/* --------------------------------------------- */}
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="product__details__tab">
                <ul className="nav nav-tabs" role="tablist">
                  <li className="nav-item">
                    <a className="nav-link active" role="tab">Description</a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div className="tab-pane active" id="tabs-1" role="tabpanel">

                    <p>{productData.description}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>)}
      {imgSrc && (<section >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h6 className="coupon__link">
                <span ></span>
              </h6>
            </div>
          </div>
          <form action="#" className="checkout__form" ref={formRef}>
            <div className="row">
              <div className="col-lg-8">
                <h5>DÉTAILS DE LA COMMANDE</h5>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <div className="checkout__form__input">
                      <p>Prénom <span>*</span></p>
                      <input type="text" onChange={(e) => setPrenom(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <div className="checkout__form__input">
                      <p>Nom <span>*</span></p>
                      <input type="text" onChange={(e) => setNom(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <div className="checkout__form__input">
                      <p>Gouvernorat <span>*</span></p>
                      <input type="text" onChange={(e) => setGouvernorat(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <div className="checkout__form__input">
                      <p>Ville <span>*</span></p>
                      <input type="text" onChange={(e) => setVille(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="checkout__form__input">
                      <p>Adresse <span>*</span></p>
                      <input type="text" placeholder="Rue, appartement" onChange={(e) => setAdresse(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <div className="checkout__form__input">
                      <p>Téléphone <span>*</span></p>
                      <input type="number" onChange={(e) => setTelephone(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="checkout__form__input">
                      <p>Remarque concernant votre commande, ex: note spéciale pour la livraison <span>(Optionnel)</span></p>
                      <input type="text" placeholder="Optionel" onChange={(e) => setNote(e.target.value)} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="checkout__order">
                  <h5>VOTRE COMMANDE</h5>
                  <div className="checkout__order__product">
                    <ul>
                      <li>
                        <span className="top__text">Produit</span>
                        <span className="top__text__right">Total</span>
                      </li>
                      <li>{orderedQuantity}. {productData.product_name.slice(0,19)+" ..."}<span>{(orderedQuantity * productData.price) % 1 === 0 ? orderedQuantity * productData.price + ".0" : productData.price} DT</span></li>
                    </ul>
                  </div>
                  <div className="checkout__order__product">
                    <ul>
                      <li>Frais de livraison <span>{(productData.shipping_fee*1) % 1 === 0 ? (productData.shipping_fee*1) + ".0" : (productData.shipping_fee*1)} DT</span></li>
                    </ul>
                  </div>
                  <div className="checkout__order__total">
                    <ul>
                      <li>Total <span>{(orderedQuantity * productData.price + productData.shipping_fee*1) % 1 === 0 ? (orderedQuantity * productData.price + productData.shipping_fee*1) + ".0" : (orderedQuantity * productData.price + productData.shipping_fee*1)} DT</span></li>
                    </ul>
                  </div>

                  <button className="site-btn" onClick={(event) => {hundleSubmit(event)}}>
                    Passer la commande
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>)}
    </>
  );
};

export default ProductDetails;
